import $ from 'jquery';
import debounce from 'lodash.debounce';

const submenuLinks = document.querySelectorAll( '.navMain-hasSubmenu' );

function handleClick( e ) {
  $( e.currentTarget ).find( '.navMain-submenuWrapper--level-1' ).slideToggle();
  e.currentTarget.classList.toggle( 'is-open' );
}

function initEvents() {
  if ( window.innerWidth > 1024 ) {
    return;
  }

  [...submenuLinks].forEach( ( submenuLink ) => {
    submenuLink.addEventListener( 'click', handleClick );
  } );
}

function init() {
  initEvents();
  window.addEventListener( 'resize', debounce( initEvents, 250 ) );
}

export default {
  init,
};
